<template>
  <div>
    <!-- <div
      class="alert alert-custom alert-white alert-shadow fade show gutter-b"
      role="alert"
    >
      <div class="alert-icon">
        <i class="fas fa-info text-primary"></i>
      </div>
      <div class="alert-text">
        Selectionner un <strong>Prestataire</strong> pour voir le detail.
      </div>
    </div> -->
    <!--begin::Dashboard-->

    <div class="row" ref="stats">
      <div class="col-xl-12">
        <b-overlay :show="isLoading" rounded="sm">
          <!--begin::Base Table Widget 7-->
          <div class="card card-custom card-stretch gutter-b">
            <!--begin::Header-->
            <div class="card-header border-0 mt-5">
              <h3 class="card-title align-items-start flex-column text-dark">
                <span class="font-weight-bolder text-dark"
                  >Liste des services</span
                >
              </h3>
              <div class="card-toolbar">
                <b-dropdown
                  size="sm"
                  variant="link"
                  toggle-class="custom-v-dropdown btn btn-clean btn-hover-light-primary btn-sm btn-icon"
                  no-caret
                  right
                  no-flip
                >
                  <template v-slot:button-content>
                    <i class="ki ki-bold-more-ver"></i>
                  </template>
             
                  <div class="navi navi-hover" style="width: 250px">
                    <b-dropdown-text tag="div" class="navi-item">
                      <a
                        href="javascript:;"
                        class="navi-link"
                        v-b-modal.add-service-modal
                      >
                        <span class="navi-icon">
                          <i class="fas fa-plus"></i>
                        </span>
                        <span class="navi-text">Ajouter un service</span>
                      </a>
                    </b-dropdown-text>
                  </div>
        
                </b-dropdown>
              </div>
            </div>
            <!--end::Header-->
            <!--begin::Body-->
            <div class="card-body py-0 mt-n3">
              <!--begin::Table-->
              <br />
              <DxDataGrid
                key-expr="guid"
                :data-source="services"
                :columns="servicesColumns"
                :show-row-lines="true"
                :word-wrap-enabled="true"
                :show-borders="true"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :row-alternation-enabled="false"
                :hover-state-enabled="true"
                :column-auto-width="true"
                :show-column-lines="true"
                :selection="{ mode: 'none' }"
                @row-click="onRowClick"
              >
                <DxFilterRow :visible="true" />

                <DxHeaderFilter :visible="true" :allow-search="true" />
                <!-- <DxStateStoring :enabled="true" type="localStorage" storage-key="medicineList" /> -->
                <DxPager
                  :show-page-size-selector="true"
                  :allowed-page-sizes="[5, 10, 20]"
                />
                <DxGroupPanel :visible="true" />
                <DxGrouping :auto-expand-all="true" />
                <DxPaging :page-size="10" />
                <DxSearchPanel :visible="true" />
                <DxSummary>
                  <DxTotalItem
                    column="name"
                    summary-type="count"
                    display-format="{0}"
                  />
                </DxSummary>
              </DxDataGrid>
              <br />
              <!--end::Table-->
            </div>
            <!--end::Body-->
          </div>
          <!--end::Base Table Widget 7-->
        </b-overlay>
      </div>
    </div>
    <!--end::Dashboard-->

    <b-modal
      id="add-service-modal"
      ref="add-service-modal"
      title="Ajouter un service"
      size="xl"
      centered
    >
      <div class="row">
        <div class="form-group col-6">
          <label>Nom (fr) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="service.fr.name"
            :class="{ 'is-invalid': $v.service.fr.name.$error }"
          />
          <div v-if="$v.service.fr.name.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>

        <div class="form-group col-6">
          <label>Nom (en) <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            v-model="service.en.name"
            :class="{ 'is-invalid': $v.service.en.name.$error }"
          />
          <div v-if="$v.service.en.name.$invalid" class="invalid-feedback">
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-6">
          <label>Description (fr) <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            rows="3"
            v-model="service.fr.description"
            :class="{ 'is-invalid': $v.service.fr.description.$error }"
          ></textarea>
          <div
            v-if="$v.service.fr.description.$invalid"
            class="invalid-feedback"
          >
            Champ obligatoire
          </div>
        </div>

        <div class="form-group col-6">
          <label>Description (en) <span class="text-danger">*</span></label>
          <textarea
            class="form-control"
            rows="3"
            v-model="service.en.description"
            :class="{ 'is-invalid': $v.service.en.description.$error }"
          ></textarea>
          <div
            v-if="$v.service.en.description.$invalid"
            class="invalid-feedback"
          >
            Champ obligatoire
          </div>
        </div>
      </div>

      <div class="form-group ">
        <label>Image (url) <span class="text-danger">*</span></label>
        <input
          type="text"
          class="form-control"
          v-model="service.image"
          :class="{ 'is-invalid': $v.service.image.$error }"
        />
        <div v-if="$v.service.image.$invalid" class="invalid-feedback">
          Champ obligatoire
        </div>
      </div>

      <div class="form-group row">
        <label class="col-3 col-form-label">Visible ?</label>
        <div class="col-3">
          <span class="switch switch-outline switch-icon switch-success">
            <label>
              <input
                type="checkbox"
                name="select"
                v-model="service.isActive"
              />
              <span></span>
            </label>
          </span>
        </div>
      </div>

      <template v-slot:modal-footer>
        <b-overlay :show="isLoading" rounded="sm">
          <button type="button" class="btn btn-success" @click="addService()">
            Valider
          </button>
        </b-overlay>
        <button
          type="button"
          class="btn btn-secondary"
          @click="$bvModal.hide('add-service-modal')"
        >
          Fermer
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import {
  DxDataGrid,
  //DxColumn,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxPaging,
  //DxStateStoring,
  DxPager,
  DxHeaderFilter,
  DxFilterRow,
  DxSummary,
  DxTotalItem,
} from "devextreme-vue/data-grid";

import servicesService from "../../../services/services.service";
import userService from "../../../services/user.service";
import SweetAlert2 from "../../../helpers/sweetAlert2.helper";
export default {
  mixins: [validationMixin],
  name: "partners-list",
  components: {
    DxDataGrid,
    //DxColumn,
    DxGrouping,
    DxGroupPanel,
    DxSearchPanel,
    DxPaging,
    //DxStateStoring,
    DxPager,
    DxHeaderFilter,
    DxFilterRow,
    DxSummary,
    DxTotalItem,
  },
  data() {
    return {
      isLoading: false,
      services: [],
      service: { fr: {}, en: {} },
      partnerTypes: [],
      servicesColumns: [
        { dataField: "name", caption: "Service" },
        { dataField: "description", caption: "Description" },
        { dataField: "isActive", caption: "Visible ?" },
      ],
    };
  },
  validations: {
    service: {
      fr: {
        name: {
          required,
        },
        description: {
          required,
        },
      },
      en: {
        name: {
          required,
        },
        description: {
          required,
        },
      },
      image: {
        required,
      },
    },
  },
  created() {},
  beforeDestroy() {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Services", route: "list" },
      { title: "Liste" },
    ]);

    this.getServices();
  },
  methods: {
    getServices: function() {
      this.isLoading = true;
      servicesService.getServices().then((result) => {
        this.services = result.data;
        this.isLoading = false;
      });
    },
    addService() {
      this.$v.service.$touch();
      if (this.$v.service.$anyError) {
        return;
      }

      SweetAlert2.question(
        "Confirmation",
        "Voulez-vouz ajouter ce service ?"
      ).then((result) => {
        this.isLoading = true;
        if (result.isConfirmed) {
          servicesService
            .addService(this.service)
            .then(() => {
              this.isLoading = false;
              SweetAlert2.success("L'opération a réussi", "");
              this.getServices();
              this.$bvModal.hide("add-service-modal");
            })
            .catch(() => {
              this.isLoading = false;
              SweetAlert2.error("Une erreur s'est produite", "");
            });
        }
      });
    },
    onRowClick(e) {
      if (e.rowType === "data") {
        this.$router.push({
          name: "services-detail",
          params: { guid: e.data.guid },
        });
      }
    },
    refresh() {
      this.dataGridInstance.refresh();
    },
    hasRoles(roles) {
      return userService.hasRoles(roles);
    },
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
};
</script>
